import type { CSSProperties } from 'react';
import '../components/atomic/layout/app_screen/app_screen.css';
import { containFitScale } from '../../../infrastructure/runtime';
import { useAppFit } from '../../hooks/useAppFit';
import { SunBeams } from '../components/atomic/atmosphere/sun_beams/SunBeams';
import { GoBackButton } from '../components/atomic/buttons/go_back_button/GoBackButton';
import { InfoPopupButton } from '../components/atomic/buttons/info_popup_button/InfoPopupButton';
import { CenterPlaqueFrame } from '../components/atomic/dialog/center_plaque_frame/CenterPlaqueFrame';
import { InfoPopupFrame2 } from '../components/atomic/dialog/info_popup_frame_2/InfoPopupFrame2';
import { ScreenHeader } from '../components/atomic/layout/screen_header/ScreenHeader';
import { SkyAtmosphere } from '../components/composite/atmosphere/sky_atmosphere/SkyAtmosphere';
import bodyTextSvg from './info_popup/body_text.svg';
import './info_popup/RatingInfoPopup.css';
import titleTextSvg from './info_popup/title_text.svg';
import { StarIcon } from './star_icon/StarIcon';
import type { RatingScreenController } from './RatingScreenController';
import type { RatingScreenModel } from './RatingScreenModelScreen';
import { HeaderText } from './texts/HeaderText';
import { PlaqueContent } from './texts/PlaqueContent';
import './rating_screen.css';
import type { ScreenViewProps } from '../shared/screenViewProps';

export type RatingScreenViewProps = ScreenViewProps<
  RatingScreenModel,
  RatingScreenController
>;

/** Rating screen stub. */
export function RatingScreenView({ model, controller }: RatingScreenViewProps) {
  const fit = useAppFit();
  const contain = containFitScale(fit.scale);

  return (
    <div className="app-screen rating-screen">
      <SkyAtmosphere variant="welcome" />
      <SunBeams className="rating-screen__sun-beams" />
      <div
        className="rating-plaques"
        style={
          {
            '--fit-contain-inv-x': String(contain.invX),
            '--fit-contain-inv-y': String(contain.invY),
            '--fit-contain-uniform': String(contain.uniform),
          } as CSSProperties
        }
      >
        <ScreenHeader showSubHeader={false} />
        <HeaderText />
        <CenterPlaqueFrame />
        <PlaqueContent averageRating={model.averageRating} />
        <StarIcon />
        <InfoPopupButton
          className={model.infoOpen ? 'info-popup-button--above-popup' : undefined}
          left={919}
          top={162}
          scale={1.503672}
          onClick={controller.handleInfoButtonClick}
        />
        {model.infoOpen ? (
          <InfoPopupFrame2
            titleSrc={titleTextSvg}
            bodySrc={bodyTextSvg}
            titleClassName="rating-info-popup__title"
            bodyClassName="rating-info-popup__body"
            titleAlt="Average rating is the courier's main score."
            bodyAlt="The better you complete deliveries, the higher your rating, rewards, and status. You can always replay deliveries to improve it."
            onClose={controller.handleInfoClose}
          />
        ) : null}
        <GoBackButton onClick={controller.handleGoBack} />
      </div>
    </div>
  );
}
